import { BigNumber } from 'ethers';
import moment from 'moment'

export type Idatetime = (v : BigNumber|string|number|null) => string;

export default function datetime(v : BigNumber|string|number|null): string {
    return v ? moment.unix(Number(String(v))).calendar() : '-'
}